import { html } from "lit";
var icon_audienceExplorer_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      d="M18.3 12.3v1.4h-3.5l4.5 4.6-1 1-4.6-4.5v3.4h-1.4v-6h6v.1zm-10.6 0v6H6.3v-3.5l-4.5 4.5-1-1 4.5-4.6H1.7v-1.4h6zM18.4.7l1 1-4.5 4.6h3.4v1.5h-6v-6h1.6v3.4L18.1.7h.3zM1.6.7l4.5 4.5V1.7h1.5v6h-6V6.3h3.5L.7 1.8l1-1-.1-.1z"
      fill-rule="evenodd"
      clip-rule="evenodd" />
  </svg>
`;
export {
  icon_audienceExplorer_default as default
};
//# sourceMappingURL=icon-audienceExplorer.js.map
